import { type ResponseValues } from 'axios-hooks';

import { useGetApplication } from '../../../../hooks';
import { type ReportVector } from '../models/types';

const baseUrl = 'reports';
export const useGetAllReports: (
  loadMode?: boolean
) => ResponseValues<Array<ReportVector>, any, any> = (loadMode = true) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<ReportVector>>(
    {
      url: `${baseUrl}/all`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};
